import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoAppleSafariAr211 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 108 49"
    {...props}
  >
    <g clipPath="url(#Logo_apple_safari-ar21_1_svg__a)">
      <path
        fill="url(#Logo_apple_safari-ar21_1_svg__b)"
        d="M23.194 46.386c12.284 0 22.242-9.957 22.242-22.24 0-12.281-9.958-22.238-22.242-22.238S.95 11.865.95 24.147s9.958 22.239 22.243 22.239"
      />
      <path
        fill="url(#Logo_apple_safari-ar21_1_svg__c)"
        d="M23.194 44.533c11.26 0 20.39-9.127 20.39-20.386 0-11.26-9.13-20.386-20.39-20.386s-20.39 9.127-20.39 20.386 9.129 20.386 20.39 20.386"
      />
      <path
        stroke="#DEDEDD"
        strokeLinecap="round"
        strokeWidth={0.459}
        d="M23.194 5.063V8.3m0 34.93v-3.243M25.06 5.152l-.14 1.385m-3.603 36.605.14-1.386m20.825-17.609h-3.25m-34.942 0h3.244m34.859 1.872-1.386-.14M4.185 22.27l1.386.14m31.12-11.758-2.296 2.29M9.69 37.641l2.295-2.29m25.962-23.32-1.073.886M8.43 36.257l1.073-.885m27.188 2.27-2.295-2.29M9.69 10.653l2.295 2.29M35.3 38.9l-.878-1.073M11.08 9.39l.88 1.072m18.536-3.95-1.244 3m-13.37 32.27 1.244-3M32.19 7.312l-.655 1.225M14.192 40.981l.654-1.224m25.985-8.308-2.994-1.238M5.555 16.845l2.994 1.238m31.476 15.065-1.224-.66M6.355 15.145l1.225.66m33.245 1.04-2.994 1.237M5.555 31.449l2.994-1.238m32.912-11.603-1.334.404M4.92 29.686l1.335-.404m24.242 12.5-1.244-3m-13.37-32.27 1.244 3M28.734 42.41l-.405-1.327M17.648 5.883l.404 1.327m8.861-1.782-.628 3.18m-6.811 34.258.628-3.18m8.637-33.803-.404 1.327m-10.687 35.2.404-1.326m23.865-13.212-3.186-.635m-34.266-6.81 3.186.635m33.811 8.629-1.334-.404M4.92 18.608l1.335.404m32.808-5.468-2.7 1.8M7.319 34.75l2.7-1.801m30.006-17.803-1.225.665M6.355 33.151l1.225-.66m26.218 7.533-1.801-2.699M12.582 8.273l1.802 2.7M32.19 40.98l-.655-1.224M14.192 7.313l.654 1.224m18.953-.264-1.802 2.7M12.582 40.02l1.802-2.699M35.299 9.39l-.878 1.072M11.08 38.9l.88-1.073m27.102-3.077-2.7-1.801M7.319 13.544l2.7 1.801m27.93 20.912-1.074-.885M8.43 12.032l1.073.886m32.414 7.51-3.186.634m-34.266 6.81 3.186-.635m34.542-4.962-1.386.14m-36.622 3.61 1.386-.14m21.342 16.987-.628-3.18m-6.811-34.26.628 3.18m4.964 34.534-.14-1.385M21.32 5.156l.14 1.386"
      />
      <path
        fill="#DEDEDD"
        d="m21.16 22.114 2.034 2.032L9.198 38.14z"
      />
      <path
        fill="#EE4544"
        d="M37.178 10.158 23.194 24.151l-2.033-2.032z"
      />
      <path
        fill="#CB2026"
        d="m25.22 26.18-2.026-2.034 13.984-13.993z"
      />
      <path
        fill="#ABABAB"
        d="m25.22 26.18-2.026-2.033L9.198 38.14z"
      />
      <path
        fill="currentColor"
        d="m49.928 29.996 2.948.858c.971.21 1.959.21 2.915-.113.81-.28 1.393-.793 1.539-1.668.162-.924-.114-1.75-.924-2.24-.81-.489-1.7-.825-2.542-1.246-.81-.405-1.669-.761-2.397-1.295-2.818-2.089-2.543-6.121.513-7.854 1.798-1.02 3.725-1.1 5.7-.761.654.113 1.296.34 1.927.534.308.097.438.292.308.653-.242.697-.437 1.409-.653 2.089-.907-.227-1.75-.513-2.591-.616-.745-.08-1.523-.016-2.252.13-.81.178-1.393.713-1.538 1.587-.13.874.242 1.554.971 1.975.73.42 1.49.745 2.252 1.1.761.373 1.571.697 2.3 1.134 1.68 1.037 2.494 2.591 2.316 4.571-.162 1.976-1.199 3.405-3.012 4.162-2.689 1.133-5.377.907-8.034-.162-.34-.13-.453-.34-.34-.696.21-.713.405-1.458.583-2.138zm19.792 2.186-.583.453c-1.539 1.15-3.219 1.458-5.004.713-2.613-1.101-3.013-4.793-.778-6.656 1.41-1.166 3.11-1.458 4.86-1.587.113-.017.226 0 .34 0 .955-.033 1.1-.28.696-1.166-.388-.859-1.343-1.36-2.612-1.182-.924.13-1.83.453-2.737.696-.13.033-.243.097-.437.162-.195-.653-.405-1.263-.535-1.878-.033-.13.227-.389.405-.486a8.77 8.77 0 0 1 4.389-.842c.696.048 1.425.13 2.073.356 1.912.68 2.705 2.218 2.9 4.13.064.728.048 1.457.048 2.17v6.363c-.778 0-1.68.017-2.576-.016-.097 0-.226-.243-.28-.405-.08-.21-.113-.453-.178-.825zm-.194-3.79c0-.242.032-.486-.017-.728-.032-.146-.194-.373-.291-.389-1.2-.033-2.397.033-3.385.842-.68.55-.842 1.555-.437 2.348.34.68 1.117 1.004 2.008.842 1.458-.28 2.122-1.198 2.122-2.915m13.949-4.739-.535-1.846c-.033-.145.178-.421.34-.502 1.36-.696 2.818-.923 4.325-.907q.504-.003 1.004.065c2.543.357 4.065 2.089 4.13 4.745l.097 7.028c0 .372.049.745.082 1.198-.908 0-1.799.017-2.69-.016-.112 0-.258-.227-.307-.372-.081-.227-.113-.486-.195-.842-.242.194-.42.308-.583.437-1.538 1.15-3.219 1.458-4.988.713-1.328-.55-2.053-1.636-2.187-3.06-.145-1.733.502-3.093 1.992-4.012 1.28-.792 2.737-1.052 4.211-1.166.259-.016.513-.032.777-.016.437 0 .535-.21.486-.616-.13-.858-.68-1.457-1.603-1.635-1.23-.259-2.397 0-3.547.453-.243.098-.47.21-.81.357zm6.074 4.777c0-.26.032-.535-.017-.778-.032-.145-.194-.356-.307-.356-1.167-.033-2.317.049-3.289.777-.696.513-.907 1.571-.534 2.38.324.68 1.1 1.02 1.992.875 1.458-.28 2.154-1.215 2.154-2.898M82.4 17.37l-1.1-.146c-1.183-.081-1.944.437-2.22 1.587-.097.437-.13.874-.162 1.328-.032.388.162.534.535.513h1.782c.292 0 .47.065.454.405v2.105h-1.883c-.874 0-.874 0-.874.906v8.6c0 .242-.033.469-.049.776-1.004 0-1.976.017-2.931-.016-.114 0-.28-.195-.308-.34-.049-.195-.017-.406-.017-.616v-8.5c0-.826 0-.81-.793-.826-.988-.016-.924.162-.924-.923v-1.117c-.016-.341.13-.454.454-.47 1.23-.049 1.23-.066 1.328-1.343.162-2.333 1.409-4 3.466-4.572.988-.28 1.992-.21 2.997-.016.388.081.513.28.47.664-.114.664-.162 1.311-.227 1.991zm15.927 5.274.389-.583c.793-1.101 1.83-1.717 3.219-1.668.388.016.583.13.567.55v2.575l-.713-.033c-1.62-.08-2.754.793-3.077 2.38a6.7 6.7 0 0 0-.13 1.393v6.17c-1.037 0-2.04 0-3.029-.017-.08 0-.21-.145-.242-.242-.049-.162-.033-.324-.033-.502l-.081-11.498c0-.372.097-.534.502-.534h1.846c.422-.016.55.162.55.567l.066 1.408c.049 0 .114.017.162.033zm5.458 4.388-.017-5.748c0-.486.13-.664.632-.653h2.17c.372-.017.551.113.535.502V32.97c0 .324-.114.47-.454.453a37 37 0 0 0-2.348 0c-.486.017-.551-.21-.551-.616l.033-5.78zm1.663-8.128c-1.085 0-1.814-.697-1.814-1.75s.762-1.797 1.847-1.797c1.053.016 1.798.76 1.798 1.797s-.746 1.75-1.831 1.75"
      />
    </g>
    <defs>
      <radialGradient
        id="Logo_apple_safari-ar21_1_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(22.5697 0 0 22.5656 23.399 25.044)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#69CCE3" />
        <stop
          offset={1}
          stopColor="#396FB6"
        />
      </radialGradient>
      <linearGradient
        id="Logo_apple_safari-ar21_1_svg__b"
        x1={25.906}
        x2={25.906}
        y1={4.016}
        y2={47.096}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F7F8F8" />
        <stop
          offset={1}
          stopColor="#CDCCCC"
        />
      </linearGradient>
      <clipPath id="Logo_apple_safari-ar21_1_svg__a">
        <path
          fill="#fff"
          d="M.615.147h107v48h-107z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoAppleSafariAr211;
